export default class Lobby {
    users = []
    requests = []
    activeRequests = []
    requests_challenges = []
    filters = []

    constructor() {

        this.connect()
    }

    connect() {
        //do not load lobby when user is creating any entry
        if (location.href.indexOf("create") > -1) return;
        //do not load Lobby when user is in game
        if (location.href.indexOf("games") > -1) return;

        Echo.join('matchrequests')
            .here(users => {
                this.users = users;
                this.updateRequests();
            })
            .joining(user => {
                this.users.push(user);
                this.updateRequests();
            })
            .leaving(user => {
                for (let i = 0; i < this.users.length; i++) {
                    const u = this.users[i];
                    if (u.id == user.id) {
                        this.users.splice(i,1);
                    }
                }
                this.updateRequests();
            })

        this.reloadRequests();

        Echo.channel('matchrequests')
        .listen('.request.created', (e) => {
            this.requests = e.match_requests;
            this.updateRequests();
        })
    }

    reloadRequests() {
        axios.get('/matchrequests.json').then(response => {
            this.requests = response.data;
            this.updateRequests();
        });

        axios.get('/matchrequests/challenges').then(response => {
            this.requests_challenges = response.data;
            this.updateRequests();
        });
    }

    updateRequests() {
        this.activeRequests = [];
        this.requests_challenges.forEach(req => {
            req.activeUser = false;
            this.users.forEach(user => {
                if (user.id == req.user.id) {
                    // if (this.boardfilter == 0 || this.boardfilter == req.boardtype || req.boardtype == 0) {
                        req.challenge = true;
                        req.activeUser = true;
                    // }
                }
            });
            this.activeRequests.push(req);
        });
        this.requests.forEach(req => {
            let alreadyInList = false;
            this.activeRequests.forEach(areq => {
                if (areq.id == req.id) alreadyInList = true;
            });
            if (!alreadyInList) {
                req.activeUser = false;
                this.users.forEach(user => {
                    if (user.id == req.user.id) {
                        var idfound = false;
                        this.activeRequests.forEach(ar => {
                            if (ar.id == req.id) idfound = true;
                        });
                        if (!idfound) {
                            // if (this.boardfilter == 0 || this.boardfilter == req.boardtype || req.boardtype == 0) {
                                req.activeUser = true;
                            // }
                        }
                    }
                });
                this.activeRequests.push(req);
            }
        });
        this.activeRequests = this.filterRequests();
        window.activeRequests = this.activeRequests;
    }

    filterRequests() {
        let requests = this.activeRequests;
        let returnRequests = [];
        // console.log(requests, this.filters);
            requests.forEach(request => {
                var valid = true;
                // console.log("Request", request)
                this.filters.forEach(filter => {
                    // console.log("Flter", filter)
                    if (filter.name == "average") {
                        if (parseInt(filter.value) > request.user.player.avg3) valid = false;
                    }
                    if (filter.name == "boardtype" && filter.value != 0 && request.boardtype != 0 && request.boardtype != filter.value) valid = false
                    if (filter.name == "camera1" && filter.value !== false && request.cameras == 0) valid = false
                    if (filter.name == "camera2" && filter.value !== false && request.cameras <= 1) valid = false
                    if (filter.name == "microphone" && filter.value !== false && request.microphone == 0) valid = false
                });
            if (valid) {
                returnRequests.push(request);
            }
        });
        // console.log("filtered requests: ", returnRequests);
        return returnRequests;
    }

    counter() {
        return this.users.length;
    }

    setFilter(filters) {
        this.filters = filters;
    }
}
